export default __webpack_public_path__ + "static/media/3.ff80ec79.jpg";